import styled from "styled-components";
import {
	COLOR_TEXT_HIGHLIGHT,
	COLOR_TEXT_PRIMARY_B2C,
	FONT_WT_MEDIUM,
	FONT_WT_LIGHT,
	COLOR_WHITE,
	COLOR_LIGHT_GREEN,
	FONT_WT_BOLD,
} from "@website-builder/utilities-index";

export const AdmissionProcessWrapper = styled.div`
	background: ${COLOR_LIGHT_GREEN};
	padding: 70px 40px 130px 27px;

	.mainContent {
		max-width: 643px;
		margin: auto;
	}

	.stepsContainer {
		margin-top: 60px;

		.step {
			box-sizing: border-box;
			display: flex;
			line-height: 27px;
			padding-bottom: 26px;
			padding-left: 40px;
			position: relative;

			&:before {
				width: 28px;
				height: 28px;
				display: flex;
				align-items: center;
				justify-content: center;
				border-left: 1px solid ${COLOR_TEXT_HIGHLIGHT};
				border-radius: 50%;
				background: ${COLOR_TEXT_HIGHLIGHT};
				font-size: 17px;
				font-weight: ${FONT_WT_MEDIUM};
				color: ${COLOR_WHITE};
				position: absolute;
				left: 0;
				top: 0;
				content: attr(data-num);
				cursor: pointer;
				z-index: 2;
			}

			&:not(:last-child) {
				&:after {
					content: "";
					z-index: 1;
					width: 1px;
					left: 14px;
					top: 28px;
					height: 100%;
					background: ${COLOR_TEXT_HIGHLIGHT};
					position: absolute;
				}
			}

			.content {
				.stepName {
					font-weight: ${FONT_WT_BOLD};
					font-size: 20px;
				}

				.stepDetail {
					margin-top: 8px;
					font-weight: ${FONT_WT_LIGHT};
					font-size: 16px;
				}
			}
		}
	}
`;
